"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M287.2 62.5h-73.4c-94.8 0-171.6 76.8-171.6 171.6 0 51.9 24.5 98.1 62.5 127.7V427c0 9.3 11.2 13.9 17.8 7.4l36.7-44.9c14.2 4.1 29.2 6.3 44.8 6.3h93.3c89.3 0 161.7-72.4 161.7-161.7-.2-94.8-77-171.6-171.8-171.6zm30.2 211.8c7 7 7 18.4 0 25.4s-18.4 7-25.4 0l-41.5-41.5-41.5 41.5c-7 7-18.4 7-25.4 0s-7-18.4 0-25.4l41.5-41.5-41.5-41.5c-7-7-7-18.4 0-25.4s18.4-7 25.4 0l41.5 41.5 41.5-41.5c7-7 18.4-7 25.4 0s7 18.4 0 25.4l-41.5 41.5 41.5 41.5z"
  });
};

exports.default = _default;